import { useEffect, useRef, useState } from "react";
import { DatepickerRange } from "../../utils/daterange";
import { LoadingButton } from "@mui/lab";
import { TableWithSearchAndSortEngine } from "../utils/table";
import { sendServerRequest } from "../../server/request";
import { serverRequestError } from "../utils/checkservererror";
import { SelectFromItems } from "../utils/forms/select";
import { formatDateWithMin } from "../../utils/date";
import { openGlobalSnack } from "../utils/snack";
import { Button, Chip, Dialog, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import { justNumbers } from "../../utils/justnumbers";
import { CsvReaderCpfAndPhone } from "./csv";
import { FormLeadLogsPanel } from "./leadlogs";


export function UserLeads(){
    const [loading,setLoading]=useState(false);
    const [startDate,setStartDate]=useState<Date>(new Date());
    const [endDate,setEndDate]=useState<Date>(new Date());
    const [leads,setLeads]=useState<Array<any>>([]);
    const [showLeads,setShowLeads]=useState<Array<any>>([]);
    const [options,setOptions]=useState([]);
    const [state,setState]=useState('');
    const [minMarginFilter,setMinMarginFilter]=useState(0);
    const [logsLeadId,setLogsLeadId]=useState('');
    const [logsNonce,setLogsNonce]=useState(0);
    const logsRef=useRef<HTMLDivElement>(null);
    useEffect(()=>{
      let nShowLeads:Array<any>=[];
      if(state){
         for(let ld of leads){
            if(ld.consult_status==state){
                nShowLeads.push(ld);
            }
         }
      }else{
          //@ts-ignore
          nShowLeads=[].concat(leads);
      }
      if(minMarginFilter>0){
          let minMarginLeads=[];
          for(let lead of nShowLeads){
              if(lead.margin>=minMarginFilter){
                  minMarginLeads.push(lead);
              }
          }
          nShowLeads=minMarginLeads;
      }
      setShowLeads(nShowLeads);
    },[state,leads,minMarginFilter]);
    useEffect(()=>{
           if(!loading)return;
           sendServerRequest('GET','/server/userLeads/clt/options').then(e=>{
                const props=e.data.data.options;
                setOptions(props);
           });
           sendServerRequest('POST','/server/userLeads/clt',{
             from:startDate,
             to:endDate
           }).then(e=>{
              const props=e.data.data.leads;
              setLeads(props);
              setLoading(false);
           }).catch(e=>{
              serverRequestError(e);
              setLoading(false);
              setLeads([]);
           })
    
    },[loading]);
    return (
        <div style={{textAlign:'center'}}>
            <CsvReaderCpfAndPhone/>
            <DatepickerRange disabled={loading} title="Período de consulta." onUpdated={(s,e)=>{
             setStartDate(s);
             setEndDate(e);
        }}/>

        <LoadingButton loading={loading} onClick={()=>setLoading(true)} sx={{marginTop:'15px'}} variant="contained">Buscar Leads</LoadingButton>
       <div style={{width:'300px',margin:'auto',marginTop:'20px',marginBottom:'20px'}}>
         <SelectFromItems  label='Status' onChangeItem={(v)=>{
             setState(v);
        }}
        items={options.map(e=>{
            return {
                value:e,
                label:e
            }
        })}
        />
       </div>
       <div style={{marginTop:'20px',marginBottom:'20px',margin:'auto',width:'200px'}}>
          <TextField  fullWidth type="number"
                              helperText={`Filtre apenas leads com valor de margem maior que:`}
                              
                              label="Margem Minina"
                              value={(minMarginFilter||0).toFixed(2)}
                              onChange={(v)=>{
                                  const val=parseInt(justNumbers(v.target.value))/100;
                                  setMinMarginFilter(val);  
                              }}
                              />
       </div>
        <TableWithSearchAndSortEngine
          allowDownloadCsv={true}
          items={showLeads}
          filters={[
            {label:'Foi Chamado',
            filter:(s)=>s.is_called,},
            {
                label:'Não Foi Chamado',
                filter:(s)=>!s.is_called,
            }
          ]}
          header={[
            {
                label:'CPF',
                id:'cpf',
                showValue:(e)=>{
                    return <CopyField data={e.cpf} name={'CPF'}/>;
                }
            },
            {
                label:'Telefone',
                id:'phone',
                showValue:(e)=>{
                    return <CopyField data={e.phone} name={'Telefone'}/>;
                }
            },
            {
                label:'Status',
                id:'consult_status'
            },
            {
                label:'Nome',
                id:'name',
                showValue:(e)=>{
                    return <CopyField data={e.name} name={'Nome'}/>;
                }
            },
            {
                label:'Nascimento',
                id:'birth_date',
                showValue:(e)=>{
                    return <CopyField data={e.birth_date} name={'Nascimento'}/>;
                }
            },
            {
                label:'Margem',
                id:'margin',
                allowSort:true,
                
            },
            {
                label:'Data',
                id:'createdAt',
                showValue:(e)=>formatDateWithMin(e.createdAt),
            },
            {
               label:'Fonte',
               id:'source',
            },
            {
                label:'Ação',
                id:'action',
                hiddenCsv:true,
                showValue:(e)=>{
                     return <div style={{display:'flex',gap:'8px',justifyContent:'center',flexWrap:'wrap'}}>
                        <SetCalledButton data={e}/>
                        <DispatchButton data={e}/>
                        <ConsultHistoryButton data={e}/>
                        <ViewLogsButton id={e.id} onView={(id)=>{
                            setLogsLeadId(String(id));
                            setLogsNonce(n=>n+1);
                            setTimeout(()=>logsRef.current?.scrollIntoView({behavior:'smooth',block:'start'}),60);
                        }}/>
                     </div>
                }
            }
          ]}
        />
        <div ref={logsRef}>
          <FormLeadLogsPanel focusLeadId={logsLeadId} focusNonce={logsNonce}/>
        </div>
        </div>
    )
}



function CopyField({data,name}:{
    data:string,name:string,
}){
  return (<p style={{
                         cursor:'pointer'
                    }} onClick={()=>{
                        navigator.clipboard.writeText(data);
                        openGlobalSnack(name+' Copiado','success');
                    }}>{data}</p>)
}


function SetCalledButton({data}:{data:{id:number,is_called:boolean}}){
    const [isCalled,setIsCalled]=useState(data.is_called);
    return (
        <Button onClick={()=>{
              setIsCalled(true);
              sendServerRequest('POST','/server/userLeads/clt/setCalled/'+data.id);
        }} variant="contained" disabled={isCalled}>
          {"Definir Chamado"}
        </Button>
    )
}


// ---- Histórico de consultas do lead (clt_provider_consult_history) ----

const CONSULT_PROVIDER_LABELS:Record<string,string>={
    v8:'V8', suma_celcoin:'Suma · Celcoin', suma_uy3:'Suma · UY3',
};
function consultProviderLabel(name:string){ return CONSULT_PROVIDER_LABELS[name]??name; }

const CONSULT_STATUS_CHIP:Record<string,{label:string,color:'success'|'info'|'error'|'default'}>={
    consulted:{label:'Consultado',color:'success'},
    alreadyExists:{label:'Já existia',color:'info'},
    error:{label:'Erro',color:'error'},
};

type ConsultEntry={consultId?:string,consultedAt?:string,status?:string,errorMessage?:string};

function parseConsultHistory(raw:any):Record<string,ConsultEntry>{
    if(!raw)return {};
    try{ return typeof raw==='string'?JSON.parse(raw):raw; }catch{ return {}; }
}

function fmtHistDate(iso?:string){ if(!iso)return '—'; try{ return new Date(iso).toLocaleString('pt-BR'); }catch{ return iso; } }

// Mostra o histórico de consultas por provider deste lead (provider, status,
// consultId, data) — mesmo histórico usado no fluxo do chat.
function ConsultHistoryButton({data}:{data:any}){
    const [open,setOpen]=useState(false);
    const history=parseConsultHistory(data.clt_provider_consult_history);
    const entries=(Object.entries(history) as Array<[string,ConsultEntry]>)
        .sort((a,b)=>new Date(b[1].consultedAt||0).getTime()-new Date(a[1].consultedAt||0).getTime());
    return (
        <>
            <Button variant="outlined" onClick={()=>setOpen(true)}>
                {`Histórico${entries.length?` (${entries.length})`:''}`}
            </Button>
            <Dialog open={open} onClose={()=>setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Histórico de consultas — CPF {data.cpf}</DialogTitle>
                <DialogContent dividers>
                    {entries.length===0 ? (
                        <p style={{color:'#00000080'}}>Nenhuma consulta registrada para este lead.</p>
                    ) : (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Provider</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Consult ID</TableCell>
                                    <TableCell>Data</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {entries.map(([provider,entry])=>{
                                    const chip=CONSULT_STATUS_CHIP[entry.status||'']??{label:entry.status||'—',color:'default' as const};
                                    return (
                                        <TableRow key={provider}>
                                            <TableCell>{consultProviderLabel(provider)}</TableCell>
                                            <TableCell><Chip size="small" variant="outlined" label={chip.label} color={chip.color}/></TableCell>
                                            <TableCell style={{fontSize:11,wordBreak:'break-all',maxWidth:260}}>{entry.consultId||'—'}</TableCell>
                                            <TableCell style={{whiteSpace:'nowrap'}}>{fmtHistDate(entry.consultedAt)}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
}


// Abre os logs (consulta → disparo) filtrados por este lead, no painel abaixo.
// Mostra o detalhe real do erro: decisões offline por provider, status HTTP e
// corpo da resposta do banco.
function ViewLogsButton({id,onView}:{id:number,onView:(id:number)=>void}){
    return (
        <Button variant="outlined" onClick={()=>onView(id)}>
          {"Erros"}
        </Button>
    )
}


// Dispara manualmente o lead (mesma função do form, forçando). Em caso de não
// envio, o backend responde 403 com o motivo, que o serverRequestError exibe.
function DispatchButton({data}:{data:{id:number}}){
    const [loading,setLoading]=useState(false);
    return (
        <LoadingButton loading={loading} color="secondary" variant="contained" onClick={async()=>{
              setLoading(true);
              try{
                  const r=await sendServerRequest('POST','/server/userLeads/clt/shot/'+data.id);
                  openGlobalSnack(r.data?.data?.message||'Disparo realizado.','success');
              }catch(e){
                  serverRequestError(e);
              }finally{
                  setLoading(false);
              }
        }}>
          {"Disparar"}
        </LoadingButton>
    )
}